import { gql } from '@apollo/client'

export const ReactivateRegistration = gql`
    mutation reactivateRegistration($customerID: String!) {
        reactivateRegistration(customerID: $customerID)
    }
`
